class PriorityNav extends HTMLElement {
  constructor() {
    super();
    this.lastWindowWidth = 0;
    this.mainList = this.querySelector("#PriorityNavMainList");
    this.moreLi = this.querySelector("#PriorityNavMore");
    this.moreList = this.querySelector("#HeaderMenu-MenuList-More");

    if (!this.mainList || !this.moreLi || !this.moreList) return;

    this.onResize = this.debounce(this.handleResize.bind(this), 200);
    window.addEventListener("resize", this.onResize);

    // Wait for a frame to let styles render before initial calculation
    requestAnimationFrame(() => this.handleResize());
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  handleResize() {
    const currentWindowWidth = window.innerWidth;
    const isToShrink = currentWindowWidth < this.lastWindowWidth;

    if (this.lastWindowWidth === 0) {
      this.moreLi.hidden = false;
    }

    if (isToShrink || this.lastWindowWidth === 0) {
      while (
        (this.moreList.children.length === 0 &&
          this.mainList.children[this.mainList.children.length - 2].offsetTop >
            this.mainList.firstElementChild.offsetTop) ||
        (this.moreList.children.length > 0 &&
          this.mainList.lastElementChild.offsetTop >
            this.mainList.firstElementChild.offsetTop)
      ) {
        this.moreList.prepend(
          this.mainList.children[this.mainList.children.length - 2],
        );
      }
    } else if (!isToShrink) {
      let flag = true;
      while (this.moreList.children.length > 0 && flag) {
        this.mainList.insertBefore(
          this.moreList.firstElementChild,
          this.mainList.lastElementChild,
        );

        if (
          this.mainList.lastElementChild.offsetTop >
          this.mainList.firstElementChild.offsetTop
        ) {
          this.moreList.prepend(
            this.mainList.children[this.mainList.children.length - 2],
          );
          flag = false;
        }
      }
    }

    this.moreLi.hidden = this.moreList.children.length === 0;
    this.lastWindowWidth = currentWindowWidth >= 990 ? currentWindowWidth : 0;
  }
}

customElements.define("priority-nav", PriorityNav);
